'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { isWelcomeTourPending } from '@/components/client/tour/welcomeTourFlag';

const WelcomeTourPrompt = dynamic(
  () => import('./WelcomeTourPrompt').then((m) => ({ default: m.WelcomeTourPrompt })),
  { ssr: false }
);

/** Mounts WelcomeTourPrompt only when the signup flow armed its localStorage
 *  flag. The prompt pulls framer-motion (~43 KB gz); for every session except
 *  the one right after signup this renders null and the chunk never downloads. */
export function WelcomeTourPromptGate() {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (isWelcomeTourPending()) {
      setArmed(true);
    }
  }, []);

  return armed ? <WelcomeTourPrompt /> : null;
}
